import { render, staticRenderFns } from "./ValidationPassedDialog.vue?vue&type=template&id=584836dc&"
import script from "./ValidationPassedDialog.vue?vue&type=script&lang=js&"
export * from "./ValidationPassedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports